import { PrintHidden } from '#/components/PrintHidden/PrintHidden';
import { SearchContextHeader } from '#/modules/search/components/Context/SearchContextHeader';
import type { SearchContextHeaderData } from '#/modules/search/containers/SearchContextHeader/SearchContextHeaderData';

import { ListingViewHeaderSearchContext_Box_1 } from './ListingViewHeaderSearchContext.styled';

type Props = {
  searchContext: SearchContextHeaderData;
};

export function ListingViewHeaderSearchContext({ searchContext }: Props) {
  return (
    <PrintHidden>
      <ListingViewHeaderSearchContext_Box_1>
        <SearchContextHeader searchContext={searchContext} />
      </ListingViewHeaderSearchContext_Box_1>
    </PrintHidden>
  );
}
